import { useCallback, useState } from "react";
import { useParams } from "react-router-dom";
import langs from "../../../../common/services/languageService.js";
import { useCountPendingRequests } from "../../../../hooks/useCountPendingRequests.js";
import TradeInResult from "../../components/trade-in-result/trade-in-result.jsx";
import "../../styles/trade-in-register.scss";
import TradeInLayout from "../layout.jsx";
import TradeInNewDevice from "./components/trade-in-new-device/trade-in-new-device.jsx";
const { labels } = langs;

function TradeInRegisterAura() {
  const { isLoading, startRequest, finishRequest } = useCountPendingRequests();
  const [captchaResetHandle, setCaptchaResetHandler] = useState(null);
  const [buttonLabel, setButtonLabel] = useState();
  const [buttonEnabled, setButtonEnabled] = useState(false);
  const [buttonHidden, setButtonHidden] = useState(false);
  const [submitFn, setSubmitFn] = useState(null);
  const params = useParams();
  const sourceAppType = params.sourceAppType ?? null;

  const [formSubmitted, setFormSubmitted] = useState(false);

  const handleSuccessfulSubmit = useCallback(() => {
    setFormSubmitted(true);
    setButtonHidden(true);
  }, []);

  const handleButtonClick = useCallback(() => {
    if (!submitFn) return;
    submitFn();
  }, [submitFn]);

  return (
    <TradeInLayout
      buttonEnabled={buttonEnabled}
      buttonLabel={buttonLabel}
      handleButtonClick={handleButtonClick}
      isLoading={isLoading}
      buttonHidden={buttonHidden}
      showReCaptcha={!formSubmitted}
      setCaptchaResetHandler={setCaptchaResetHandler}
    >
      {!formSubmitted && (
        <TradeInNewDevice
          sourceAppType={sourceAppType}
          requestProps={{ isLoading, startRequest, finishRequest }}
          formSubmitProps={{
            setSubmitFn,
            handleSuccessfulSubmit,
            handleSubmitError: captchaResetHandle,
            setButtonLabel,
            setButtonEnabled,
          }}
          transactionId={params.transactionId}
        />
      )}
      {formSubmitted && (
        <TradeInResult
          message={labels.ThanksForUsingOffer()}
          formSubmitProps={{
            setSubmitFn,
            setButtonLabel,
          }}
        />
      )}
    </TradeInLayout>
  );
}

export default TradeInRegisterAura;
